import { createNativeStackNavigator } from '@react-navigation/native-stack';
import DownloadAppScreen from 'screens/DownloadApp';
import LegalTermsScreen from 'screens/Help/LegalTermsScreen';
import TvLegalTermsScreen from 'screens/Help/LegalTermsScreen.ctv';
import LoginScreen from 'screens/Login';
import { Platform } from 'utils/platform';

const Stack = createNativeStackNavigator();

export const AuthStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false, title: 'Bandplay' }}>
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen
        name="LegalTerms"
        component={Platform.isTV ? TvLegalTermsScreen : LegalTermsScreen}
        options={{
          headerShown: false,
        }}
      />
      {Platform.OS === 'web' && !Platform.isTV && (
        <Stack.Screen
          name="DownloadApp"
          component={DownloadAppScreen}
          options={{ title: 'Baixe o app Bandplay' }}
        />
      )}
    </Stack.Navigator>
  );
};
